import React, { PropsWithChildren } from 'react';
import * as Styled from './styled';
import { TBluredContentProps } from './types';

export const BluredContent: React.FC<PropsWithChildren<TBluredContentProps>> = ({ children, blurContent }) => (
  <Styled.BluredWrapper $blurContent={blurContent} data-testid="blured-content-wrapper">
    {children}
  </Styled.BluredWrapper>
);
